




import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import { TransactionStatus } from '@/modules/transaction/models/transaction-resource.model'

@Component
export default class TransactionStatusView extends Vue {
  @Prop({ required: true }) status: TransactionStatus
  @Prop({ required: true }) statuses!: { [key in TransactionStatus]: string }
  @Prop({ default: false }) dark: boolean

  get statusColor() {
    switch (this.status) {
      case TransactionStatus.PAID:
        return 'text-green'
      case TransactionStatus.UNPAID:
        return 'text-red'
      case TransactionStatus.PENDING:
        return this.dark ? 'text-yellow' : 'text-amber-7'
      case TransactionStatus.WAITING_PAYMENT:
        return 'text-blue'
      default:
        return ''
    }
  }
}
